export interface KeyValueInterface {
  key: string;
  value: string;
}

export interface NameValueInterface {
  name: string;
  value: number;
}

export interface ApplicationInterface {
  firstName: string;
  lastName: string;
  onboarded: string;
  applied: string;
  picture: string;
  phone: string;
  company: string;
  companyAddress: string;
  organisationNumber: string;
  certificateFile: string;
  yearOfCertification: number;
  linkedinUrl: string;
  coachingHours: number;
  languagesNative: Array<string>;
  languagesProfessional: Array<string>;
  experienceByArea: Array<NameValueInterface>;
  experienceByIndustry: Array<string>;
  experienceByRole: Array<NameValueInterface>,
  experienceProfessional: Array<NameValueInterface>;
  workedInIndustry: Array<string>;
  additionalLanguages: string;
  additionalAreas: string;
  additionalIndustriesCoach: string;
  additionalIndustriesClient: string;
}

export const experienceLevels: Array<NameValueInterface> = [
  {
    name: "Extensive", value: 3
  },
  {
    name: "Moderate", value: 2
  },
  {
    name: "Basic", value: 1
  },
  {
    name: "None", value: 0
  }
]